<template>
  <div id="largescreen" :style="_isMobile() ? {} : largescreenPcStyle">
    <el-row :gutter="10">
      <el-col :lg="24" :md="24" :sm="24" :xs="24">
        <top-header/>
      </el-col>
    </el-row>
    <el-row :gutter="10" style="padding: 10px;height: calc(100% - 60px);">
      <el-col :lg="6" :md="6" :sm="6" :xs="24">
        <body-left-top :area-name="areaName" :day-install-count="dayInstallCount"/>
        <body-left-center :area-name="areaName" :day-use-number="dayUseNumber"/>
        <body-left-bottom :area-name="areaName" :month-use-number="monthUseNumber"/>
        <!-- <body-left-bottom :area-name="areaName" :da-tj-information="daTjInformation"/> -->
      </el-col>
      <el-col :lg="12" :md="12" :sm="12" :xs="24">
        <div class="date-range">
          <el-date-picker
              v-model="dateRange"
              type="daterange"
              align="right"
              size="mini"
              unlink-panels
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="yyyy-MM-dd"
              :picker-options="pickerOptions"
              @change="onDateRangeChange"
          >
          </el-date-picker>
          <!-- ✅ 恢复默认按钮：仅在用户选择了自定义范围时显示 -->
          <el-button 
            v-if="isCustomDateRange"
            size="mini" 
            type="warning"
            icon="el-icon-refresh-left"
            @click="resetToDefaultRange"
            style="margin-left: 8px;"
          >
            恢复默认
          </el-button>
        </div>
        <div class="map-item-totalInstallation">
          装机 {{ totalInstallation }} 台
          <el-button 
            type="text" 
            size="small" 
            class="map-back-btn" 
            v-if="areaCode !== '000000'"
            @click="$refs.chinaMap.back()"
          >
            ← 返回
          </el-button>
        </div>
        <div class="map-item-activeDevices">
          活跃 {{ activeDeviceCount }} 台
        </div>
        <china
            ref="chinaMap"
            :area-code.sync="areaCode"
            :area-level.sync="areaLevel"
            :area-name.sync="areaName"
            :map-name-list.sync="mapNameList"
            :map-code-list.sync="mapCodeList"
            :area-statistic="areaStatistic"
        />
        <body-center-bottom
            :area-name="overviewAreaName"
            :overview="overview"
        />
      </el-col>
      <el-col :lg="6" :md="6" :sm="6" :xs="24">
        <!-- <el-carousel trigger="click" :interval="6666"> -->
          <!-- <el-carousel-item> -->
            <body-right-top  :equipment-installation-pass-rate="equipmentInstallationPassRate"/>
          <!-- </el-carousel-item> -->
          <!-- <el-carousel-item>
            <body-right-top1 :area-name="areaName" :map-name-list="mapNameList"/>
          </el-carousel-item> -->
        <!-- </el-carousel> -->
        <!-- <body-right-center :satisfied="satisfied"/> -->
        <body-right-center :area-name="areaName" :top10-equipment="top10Equipment"/>
        <body-right-bottom :area-name="areaName" :quality-control="qualityControl"/>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import China from "./components/china";
import TopHeader from "./components/topHeader";
import BodyLeftTop from "./components/bodyLeftTop";
import BodyLeftCenter from "./components/bodyLeftCenter";
import BodyLeftBottom from "./components/bodyLeftBottom";
import BodyRightTop from "./components/bodyRightTop";
// import BodyRightTop1 from "./components/bodyRightTop1";
import BodyRightCenter from "./components/bodyRightCenter";
import BodyRightBottom from "./components/bodyRightBottom";
import BodyCenterBottom from "./components/bodyCenterBottom";
import {
  getDashboardData,
  getProvinceEquipmentCounts,
  getOverview
} from '@/api/dashboard'


export default {
  name: "index",
  components: {
    BodyCenterBottom,
    TopHeader,
    China,
    BodyLeftTop,
    BodyRightCenter,
    BodyLeftCenter,
    BodyLeftBottom,
    BodyRightTop,
    // BodyRightTop1,
    BodyRightBottom,
  },
  data() {
    return {
      areaCode: '000000', // 当前用的areaCode
      areaLevel: 0, // 当前用的areaLevel
      areaName: 'china', // 当前用的areaName
      overviewAreaName: 'china', // ✅ 概览部分使用的地区名称（始终为省级）
      mapNameList: [], // 当前地图上的地区名字
      mapCodeList: [], // 当前地图上的地区Code
      largescreenPcStyle: {
        position: 'fixed',
        top: 0,
        left: 0,
      },
      queryParams: {},
      areaStatistic: [], // 区域统计（用于地图展示）
      totalInstallation: 0, //装机总数
      activeDeviceCount: 0, //近30天活跃设备数
      dayInstallCount: [], // 装机数量
      dayUseNumber: [], //  天使用量
      monthUseNumber: [], // 月使用量
      equipmentInstallationPassRate: [], // 装机达标率
      top10Equipment: [], // top10设备
      qualityControl: [], // 质控数据
      overview: {}, // 概览数据
      dateRange: [], // 时间段
      isCustomDateRange: false, // ✅ 标记用户是否手动选择了日期范围
      loading: false, // 数据加载状态
      refreshTimer: null, // 定时刷新定时器
      // ✅ 新增：数据缓存，避免重复请求
      dataCache: new Map(),
      cacheTimeout: 5 * 60 * 1000, // 缓存5分钟
      pickerOptions: {
        shortcuts: [{
          text: '最近一周',
          onClick(picker) {
            const end = new Date();
            end.setDate(end.getDate() - 1); // 结束日期为昨天
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近一个月',
          onClick(picker) {
            const end = new Date();
            end.setDate(end.getDate() - 1); // 结束日期为昨天
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近三个月',
          onClick(picker) {
            const end = new Date();
            end.setDate(end.getDate() - 1); // 结束日期为昨天
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit('pick', [start, end]);
          }
        }]
      },
    }
  },
  created() {
    this.setAreaName()
    this.setDateRange()
  },
  mounted() {
    this.loadDashboardData()
    this.loadProvinceEquipmentCounts()
    
    // ✅ 优化：设置定时刷新（每30分钟），但使用缓存机制避免重复请求
    this.refreshTimer = setInterval(() => {
      // ✅ 关键修复：如果不是用户自定义的日期范围，则更新日期范围为最新的过去7天
      if (!this.isCustomDateRange) {
        this.setDateRange()
      }
      
      // ✅ 清理过期缓存，强制重新请求最新数据
      this.clearCache()
      this.loadDashboardData()
      this.loadProvinceEquipmentCounts()
      
      // ✅ 加载概览数据（使用当前下钻 areaCode，与装机联动）
      this.loadOverviewData(this.areaCode)
    }, 30 * 60 * 1000)
  },
  beforeDestroy() {
    // ✅ 优化：清理定时器
    if (this.refreshTimer) {
      clearInterval(this.refreshTimer)
      this.refreshTimer = null
    }
    
    // ✅ 优化：清理缓存
    this.clearCache()
    
    // ✅ 优化：清理所有数据引用，帮助垃圾回收
    this.dayInstallCount = []
    this.dayUseNumber = []
    this.monthUseNumber = []
    this.equipmentInstallationPassRate = []
    this.top10Equipment = []
    this.qualityControl = []
    this.overview = {}
    this.areaStatistic = []
  },
  watch: {
    areaCode: {
      handler(val, oldVal) {
        // ✅ 优化：只有当areaCode真正改变时才重新加载数据
        if (val !== oldVal) {
          // ✅ 修复：不再清空所有缓存，保留历史缓存以提高性能
          
          this.loadDashboardData()
          this.loadProvinceEquipmentCounts()
          
          // ✅ 加载概览数据（使用当前下钻 areaCode，与装机联动）
          this.loadOverviewData(this.areaCode)
        }
      },
      deep: true
    }
  },
  methods: {
    // 设置areaName
    setAreaName() {
      if (this.areaName === '中央本级') {
        this.areaName = 'china'
      }
    },
    // 设置默认时间段，过去7天（不包括今天）
    // ✅ 优化：设置默认日期范围用于UI显示，但请求时不传递以使用后端缓存
    setDateRange() {
      const today = new Date();
      this.dateRange = [
        this._parseTime(today - 60 * 60 * 24 * 7 * 1000, '{y}-{m}-{d}'),
        this._parseTime(today - 60 * 60 * 24 * 1000, '{y}-{m}-{d}')
      ]
      this.isCustomDateRange = false // ✅ 标记为默认日期
    },
    // 时间change
    onDateRangeChange(val) {
      // ✅ 标记用户手动选择了日期范围
      this.isCustomDateRange = true
      this.loadDashboardData()
    },
    // ✅ 恢复默认日期范围（过去7天）
    resetToDefaultRange() {
      this.setDateRange() // 重新设置默认范围，isCustomDateRange 会被设为 false
      this.clearCache() // 清理缓存
      this.loadDashboardData() // 重新加载数据
      this.loadProvinceEquipmentCounts()
      
      // ✅ 加载概览数据（使用当前下钻 areaCode，与装机联动）
      this.loadOverviewData(this.areaCode)
      
      this.$message.success('已恢复为默认日期范围（过去7天）')
    },
    
    /**
     * ✅ 辅助方法：将任意层级的 areaCode 转换为省级代码（6位格式）
     */
    getProvinceAreaCode(areaCode) {
      if (!areaCode || areaCode === '000000' || areaCode === 'all') {
        return areaCode
      }
      
      const codeStr = String(areaCode)
      
      // 如果已经是省级代码（长度为2或以0000结尾），转换为6位格式
      if (codeStr.length === 2) {
        // 2位代码，补齐为6位（如 "33" -> "330000"）
        return codeStr.padEnd(6, '0')
      } else if (codeStr.endsWith('0000')) {
        // 已经是6位且以0000结尾，直接返回
        return areaCode
      }
      
      // 市级或区级代码，取前2位并补齐为6位
      return codeStr.substring(0, 2).padEnd(6, '0')
    },
    
    /**
     * 从后端API加载大屏数据
     */
    async loadDashboardData() {
      if (this.loading) return
      
      try {
        this.loading = true
        const params = {}
        
        // ✅ 概览数据使用当前下钻级别的 areaCode，与装机总数联动
        const overviewAreaCode = this.areaCode
        
        // ✅ 装机达标率始终使用全国数据，不传递 areaCode
        const nationalParams = {} // 空参数表示全国
        
        // 添加时间范围筛选（用于其他数据）
        // ✅ 优化：只有用户手动选择日期时才传递参数，默认使用后端缓存
        if (this.isCustomDateRange && this.dateRange && this.dateRange.length === 2) {
          params.startDate = this.dateRange[0]
          params.endDate = this.dateRange[1]
          nationalParams.startDate = this.dateRange[0]
          nationalParams.endDate = this.dateRange[1]
        }
        
        // 添加地区筛选（用于其他数据，如装机、使用等）
        if (this.areaCode && this.areaCode !== '000000') {
          params.areaCode = this.areaCode
        }
        
        // ✅ 优化：生成缓存key
        const cacheKey = `dashboard_${JSON.stringify(params)}`
        const nationalCacheKey = `dashboard_national_${JSON.stringify(nationalParams)}`
        
        const cachedData = this.getCachedData(cacheKey)
        const nationalCachedData = this.getCachedData(nationalCacheKey)
        
        if (cachedData && nationalCachedData) {
          // 合并数据：其他数据用地区过滤的，装机达标率用全国的
          const mergedData = {
            ...cachedData,
            passRates: nationalCachedData.passRates || [] // ✅ 装机达标率始终用全国数据
          }
          this.updateDashboardData(mergedData)
          await this.loadOverviewData(overviewAreaCode)
          return
        }
        
        // 并行请求：地区数据和全国数据
        const [res, nationalRes] = await Promise.all([
          getDashboardData(params),
          getDashboardData(nationalParams)
        ])
        
        // ✅ 优化：缓存数据
        this.setCachedData(cacheKey, res)
        this.setCachedData(nationalCacheKey, nationalRes)
        
        // 合并数据：其他数据用地区过滤的，装机达标率用全国的
        const mergedData = {
          ...res,
          passRates: nationalRes.passRates || [] // ✅ 装机达标率始终用全国数据
        }
        
        // 更新所有数据
        this.updateDashboardData(mergedData)
        
        // 加载概览数据（使用当前下钻 areaCode，与装机联动）
        await this.loadOverviewData(overviewAreaCode)
        
      } catch (error) {
        console.error('加载大屏数据失败:', error)
        this.$message({
          message: '数据加载失败，请稍后重试',
          type: 'error',
          duration: 3000
        })
      } finally {
        this.loading = false
      }
    },
    
    /**
     * 更新大屏数据（提取为独立方法）
     */
    updateDashboardData(res) {
      this.dayInstallCount = res.dailyInstalls || []
      this.dayUseNumber = res.dailyUsages || []
      this.monthUseNumber = res.monthlyUsages || []
      this.equipmentInstallationPassRate = res.passRates || []
      this.top10Equipment = res.top10Equipments || []
      this.qualityControl = res.qualityControls || []
      // ✅ 不在这里更新 overview，由 loadOverviewData 单独处理
      
      // 计算装机总数（优先使用 overview 数据中的 totalInstalled）
      if (res.overview && res.overview.totalInstalled) {
        this.totalInstallation = res.overview.totalInstalled
      }
      // 注意：totalInstallation 会在 loadProvinceEquipmentCounts() 中根据真实数据更新
    },
    
    /**
     * 加载各省装机数量（用于地图展示）
     * 注意：装机数量不受时间范围影响，始终显示该地区的设备总数
     */
    async loadProvinceEquipmentCounts() {
      try {
        const params = {}
        
        // 添加地区筛选
        if (this.areaCode && this.areaCode !== '000000') {
          params.areaCode = this.areaCode
        }
        
        // ✅ 优化：生成缓存key
        const cacheKey = `province_counts_${JSON.stringify(params)}`
        const cachedData = this.getCachedData(cacheKey)
        
        if (cachedData) {
          // console.log('使用缓存的省份数据', cacheKey)
          this.updateProvinceData(cachedData)
          return
        }
        
        // 注意：不传递时间参数，装机数量显示历史累计总数
        const res = await getProvinceEquipmentCounts(params)
        
        // ✅ 优化：缓存数据
        this.setCachedData(cacheKey, res)
        
        if (res.success && res.data) {
          this.updateProvinceData(res)
        }
      } catch (error) {
        console.error('加载各省装机数量失败:', error)
      }
    },
    
    /**
     * 更新省份数据（提取为独立方法）
     */
    updateProvinceData(res) {
      if (res.success && res.data) {
        // 转换数据格式，适配地图组件
        this.areaStatistic = res.data.map(item => ({
          // ✅ 确保 areaCode 为字符串类型
          areaCode: String(item.areaCode || ''),
          amounts: item.equipmentCount || 0,
          province: item.province,
        }))
        
        // 计算总装机数量（所有省份的总和）
        this.totalInstallation = res.data.reduce((sum, item) => {
          return sum + (item.equipmentCount || 0)
        }, 0)
      }
    },
    
    /**
     * ✅ 新增：单独加载概览数据（始终使用省级代码）
     */
    async loadOverviewData(areaCode) {
      try {
        const params = {}
        
        // 添加地区筛选
        if (areaCode && areaCode !== '000000') {
          params.areaCode = areaCode
        }
        
        // ✅ 优化：生成缓存key
        const cacheKey = `overview_${JSON.stringify(params)}`
        const cachedData = this.getCachedData(cacheKey)
        
        if (cachedData) {
          this.overview = cachedData
          // ✅ 同步活跃设备数到地图显示
          if (cachedData.activeDeviceCount !== undefined) {
            this.activeDeviceCount = cachedData.activeDeviceCount
          }
          // ✅ 更新概览地区名称
          if (cachedData.areaName) {
            this.overviewAreaName = cachedData.areaName === '全国' ? 'china' : cachedData.areaName
          }
          return
        }
        
        // 调用后端 API 获取概览数据
        const res = await getOverview(params)
        
        // ✅ 后端直接返回数据对象，不是包裹在 data 字段中
        if (res) {
          // ✅ 优化：缓存数据
          this.setCachedData(cacheKey, res)
          this.overview = res
          // ✅ 同步活跃设备数到地图显示
          if (res.activeDeviceCount !== undefined) {
            this.activeDeviceCount = res.activeDeviceCount
          }
          // ✅ 更新概览地区名称
          if (res.areaName) {
            this.overviewAreaName = res.areaName === '全国' ? 'china' : res.areaName
          }
        }
      } catch (error) {
        console.error('加载概览数据失败:', error)
      }
    },
    
    /**
     * ✅ 新增：获取缓存数据
     */
    getCachedData(key) {
      const cached = this.dataCache.get(key)
      if (!cached) return null
      
      const now = Date.now()
      if (now - cached.timestamp > this.cacheTimeout) {
        // 缓存过期，删除
        this.dataCache.delete(key)
        return null
      }
      
      return cached.data
    },
    
    /**
     * ✅ 新增：设置缓存数据
     */
    setCachedData(key, data) {
      // ✅ 限制缓存大小，最多保留10个缓存项
      if (this.dataCache.size >= 10) {
        const firstKey = this.dataCache.keys().next().value
        this.dataCache.delete(firstKey)
      }
      
      this.dataCache.set(key, {
        data,
        timestamp: Date.now()
      })
    },
    
    /**
     * ✅ 新增：清理缓存
     */
    clearCache() {
      this.dataCache.clear()
    },
  }
}
</script>

<style scoped lang="scss">
::v-deep#largescreen {
  height: 100%;
  width: 100%;
  background-size: 100% 100%;
  padding: 0;
  background-image: url("../assets/images/largescreen/home-bg.png");

  .el-col {
    height: 100%;
    position: relative;

    .date-range {
      position: absolute;
      right: 5px;
      z-index: 9;

      .el-date-editor {
        background: transparent;
        border-color: rgb(0, 186, 255);
        width: 250px;

        .el-icon-date {
          color: #fff;
        }

        .el-range-separator {
          color: #fff;
        }

        .el-range__close-icon {
          color: #fff;
        }

        .el-range-input {
          background: transparent;
          color: #fff;
        }
      }
    }

    .map-item-totalInstallation {
      position: absolute;
      z-index: 9;
      left: 10px;
      top: 30px;
      color: #fff;
      font-size: 16px;
      color: #24CFF4;
      display: flex;
      align-items: center;
      gap: 12px;

      .map-back-btn {
        color: #24CFF4 !important;
        font-size: 14px;
        font-weight: bold;
        padding: 0;
        background: transparent;
        border: none;
        cursor: pointer;
        text-decoration: underline;
      }

      .map-back-btn:hover {
        color: #fff !important;
      }
    }

    .map-item-activeDevices {
      position: absolute;
      z-index: 9;
      left: 10px;
      top: 52px;
      color: #fff;
      font-size: 16px;
      color: #50e3c2;
    }
  }

  .el-carousel {
    height: calc(33.3%);
    //margin-bottom: 10px;
    .el-carousel__container {
      height: 100%;
    }

    .el-carousel__indicator--horizontal {
      padding: 3px;
    }
  }
}

// 平板端和手机横屏适配 (>= 769px)
@media screen and (min-width: 769px) {
  ::v-deep#largescreen {
    .el-row {
      padding: 5px !important;
    }
    
    .el-col {
      .date-range {
        ::v-deep .el-date-editor {
          width: 240px !important; // ✅ 1080p 屏幕适当增加宽度
          
          // 优化输入框内边距和字体大小
          .el-input__inner {
            padding: 0 12px !important;
            font-size: 14px !important; // ✅ 增大字体提高可读性
            height: 34px !important;
            line-height: 34px !important;
          }
          
          // 优化范围分隔符
          .el-range-separator {
            padding: 0 6px !important;
            font-size: 14px !important;
            line-height: 34px !important;
          }
          
          // 优化占位符
          .el-input__icon {
            line-height: 34px !important;
          }
        }
      }
      
      .map-item-totalInstallation {
        font-size: 16px !important;

        .map-back-btn {
          font-size: 13px !important;
        }
      }
      
      .map-item-activeDevices {
        font-size: 16px !important;
      }
    }
  }
}

// ✅ 1080p 屏幕专属优化 (1920x1080)
@media screen and (min-width: 1920px) and (max-width: 2560px) and (min-height: 1080px) and (max-height: 1440px) {
  ::v-deep#largescreen {
    // 全局字体放大
    font-size: 16px !important;
    
    .el-row:nth-child(2) {
      padding: 12px !important; // ✅ 增加间距
      
      .el-col {
        padding: 8px !important; // ✅ 增加列内边距
        
        // 日期选择器优化
        .date-range {
          ::v-deep .el-date-editor {
            width: 260px !important;
            
            .el-input__inner {
              font-size: 15px !important;
              height: 36px !important;
              line-height: 36px !important;
            }
            
            .el-range-separator {
              font-size: 15px !important;
              line-height: 36px !important;
            }
          }
        }
        
        // 装机数量显示优化
        .map-item-totalInstallation {
          font-size: 18px !important;
          top: 35px !important;

          .map-back-btn {
            font-size: 16px !important;
          }
        }
        
        .map-item-activeDevices {
          font-size: 18px !important;
          top: 58px !important;
        }
      }
    }
  }
}

// 手机横屏特殊处理 (横屏且高度较小)
@media screen and (orientation: landscape) and (max-height: 768px) {
  // ✅ 确保根元素有明确高度
  html, body, #app {
    height: 100% !important;
    overflow: hidden !important; // 禁止滚动，完全占满
  }
  
  ::v-deep#largescreen {
    height: 768px !important; // ✅ 固定高度为768px
    min-height: 768px !important;
    max-height: 768px !important;
    overflow: hidden !important; // 禁止滚动
    
    // 确保使用 flex 布局，而不是 block
    .el-row {
      display: flex !important;
      flex-wrap: nowrap !important;
    }
    
    // 第一个 el-row (顶部导航) 保持正常
    .el-row:nth-child(1) {
      height: 60px !important;
      flex-shrink: 0 !important; // 不收缩
    }
    
    // 第二个 el-row (主要内容)
    .el-row:nth-child(2) {
      height: calc(768px - 60px) !important; // ✅ 固定高度：总高度减去顶部导航
      padding: 0 !important; // ✅ 移除 padding，避免影响内部组件高度计算
      
      // ✅ 所有 el-col 的通用样式
      .el-col {
        height: 100% !important; // ✅ 占满父容器高度
        margin-bottom: 0 !important;
        padding: 5px !important; // ✅ 在列内部添加 padding，替代 el-row 的 padding
        display: flex !important; // 使用 flex 布局
        flex-direction: column !important; // 垂直排列
        
        .date-range {
          position: absolute !important;
          right: 5px !important;
          margin: 0 !important;
          text-align: right !important;
          z-index: 10 !important;
          
          ::v-deep .el-date-editor {
            width: 220px !important; // ✅ 增加宽度以完整显示日期
            max-width: none !important;
            
            // 优化输入框内边距和字体大小
            .el-input__inner {
              padding: 0 8px !important;
              font-size: 11px !important;
              height: 28px !important;
              line-height: 28px !important;
            }
            
            // 优化范围分隔符
            .el-range-separator {
              padding: 0 4px !important;
              font-size: 11px !important;
              line-height: 28px !important;
            }
            
            // 优化占位符
            .el-input__icon {
              line-height: 28px !important;
            }
          }
        }
        
        .map-item-totalInstallation {
          position: absolute !important;
          left: 10px !important;
          top: 30px !important;
          font-size: 12px !important;
          text-align: left !important;
          margin: 0 !important;

          .map-back-btn {
            font-size: 11px !important;
          }
        }
        
        .map-item-activeDevices {
          position: absolute !important;
          left: 10px !important;
          top: 46px !important;
          font-size: 12px !important;
          text-align: left !important;
          margin: 0 !important;
        }
      }
      
      // 左侧列：占 25%
      .el-col:nth-child(1) {
        width: 25% !important;
        max-width: 25% !important;
        flex: 0 0 25% !important;
      }
      
      // 中间列：占 50%
      .el-col:nth-child(2) {
        width: 50% !important;
        max-width: 50% !important;
        flex: 0 0 50% !important;
      }
      
      // 右侧列：占 25%
      .el-col:nth-child(3) {
        width: 25% !important;
        max-width: 25% !important;
        flex: 0 0 25% !important;
      }
    }
  }
}

// 手机竖屏适配 (小于768px 且 高度大于宽度)
@media screen and (max-width: 768px) and (orientation: portrait) {
  ::v-deep#largescreen {
    overflow-y: auto;
    height: auto !important;
    min-height: 100vh;
    
    .el-row {
      padding: 5px !important;
      height: auto !important;
      display: block !important;
    }
    
    .el-col {
      height: auto !important;
      margin-bottom: 10px;
      width: 100% !important;
      max-width: 100% !important;
      flex: 0 0 100% !important;
      
      .date-range {
        position: relative !important;
        right: auto !important;
        margin: 10px 0;
        text-align: center;
        
        .el-date-editor {
          width: 90% !important;
          max-width: 300px;
        }
      }
      
      .map-item-totalInstallation {
        position: relative !important;
        left: auto !important;
        top: auto !important;
        font-size: 14px !important;
        text-align: center;
        margin: 10px 0 0 0;
        justify-content: center;

        .map-back-btn {
          font-size: 12px !important;
        }
      }
      
      .map-item-activeDevices {
        position: relative !important;
        left: auto !important;
        top: auto !important;
        font-size: 14px !important;
        text-align: center;
        margin: 5px 0;
      }
    }
  }
}
</style>
